   <app-header></app-header> 

   <div class="container-fluid" style="background-color: #f8f9fb;">  
    <div class="form-section" [ngStyle]="{'background': backgroundImageUrl}">
        <div class="row p-0 m-0 d-flex justify-content-center align-items-center" style="height: 90vh;">
            <div class="col-md-7 d-flex justify-content-center align-items-center flex-column">
                <div class="card transparent-card text-center">
                    <h1>Your Trusted Partner in {{ serviceName }} schedule a meeting Today</h1>
                    <a href="/contactUs" class="btn btn-orange small-button">Schedule a Meeting</a>
                </div>
            </div>

            <div class="col-md-5">
                <div class="form-container">
                    <h2>GET IN TOUCH</h2>
                    <h3 class="slogan">Your journey to financial freedom starts here!</h3>
                    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
                        <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
                        <input type="email" formControlName="email" placeholder="Enter your Email" required>
                        <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
                        <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
                        <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
                        <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
                    </form>

                    <div *ngIf="submissionSuccess" class="success-message">
                        {{ successMessage }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

  
  <div class="container" >
    <div class="row text-center py-4" style="font-family: 'Poppins', sans-serif;">
      <div class="row">
        <h2 class="fw-bold" style="color: #273C66; font-size: 1.9rem; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
          Our Vision & Mission
        </h2>
        <p style="font-size: 1.2rem; color: #555;">
          Discover our commitment to empowering your financial future.
        </p>
      </div>
  
      <div class="row justify-content-center">
        <div class="col-md-5">
          <div class="card shadow-sm h-100" style="border-radius: 10px; transition: transform 0.3s ease;">
            <div class="card-body d-flex flex-column align-items-center text-center p-4">
              <div class="icon-wrapper mb-4">
                <img src="assets/vision/visio.png" alt="Vision Icon" style="width: 50px;">
              </div>
              <h3 class="fw-bold" style="color: #273C66; font-size: 1.7rem;">Vision</h3>
              <p style="font-size: 1.1rem; color: #555;">
                To become the most trusted Goal-Based Financial Products & Solutions Provider, helping clients achieve financial freedom and wealth creation.
              </p>
            </div>
          </div>
        </div>
  
        <div class="col-md-5">
          <div class="card shadow-sm h-100" style="border-radius: 10px; transition: transform 0.3s ease;">
            <div class="card-body d-flex flex-column align-items-center text-center p-4">
              <div class="icon-wrapper mb-4">
                <img src="assets/vision/targe.png" alt="Mission Icon" style="width: 50px;">
              </div>
              <h3 class="fw-bold" style="color: #273C66; font-size: 1.7rem;">Mission</h3>
              <p style="font-size: 1.1rem; color: #555;">
                To help clients achieve financial freedom and grow wealth through financial planning and innovative financial solutions, provided by a team of financial experts and advisors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-12 text-center m-3 mt-5">
        <h2 class="fw-bold" style="color: #273C66; font-size: 2rem; text-decoration: underline; text-decoration-color: red; text-underline-offset: 12px;">
          About SNP Money
        </h2>
      </div>
      <div class="col-md-6">
        <img src="assets/tf/tf.jpg" alt="Financial Planning" style="width: 100%; max-height: 350px; object-fit: cover;">
      </div>
      
      <div class="col-md-6">
      
        <p style="font-size: 1.1rem; color: #273C66;">
          <strong>SNP Money</strong> is the brand name of <strong>SNP Wealth Private Limited</strong>, working with individuals and businesses to manage their personal finances and achieve their financial goals such as 
          <strong>Retirement Planning</strong>, <strong>Child Education Planning</strong>, <strong>Investment Planning</strong>, <strong>Tax Optimization</strong>, and <strong>Insurance Planning</strong>.
        </p>
      </div>
    </div>
  
    <div class="row ">
      <div class="col-md-12 text-center m-3 mt-5">
        <h2 class="fw-bold" style="color: #273C66; font-size: 2rem; text-decoration: underline; text-decoration-color: red; text-underline-offset: 12px;">
          About CEO - Mr. Sunil Srivastava
        </h2>
      </div>
      <div class="col-md-6">
     
        <p style="font-size: 1.1rem; color: #555;">
          Mr. Sunil Srivastava is passionate about helping individuals and businesses achieve financial freedom and wealth creation through his extensive experience in the financial domain and expertise in investment planning.
        </p>
        <p style="font-size: 1.1rem; color: #555;">
          He has a total work experience of 18 years in the Financial Sector, having worked with top-level banks like HDFC BANK, KOTAK MAHINDRA BANK, and INDUSIND BANK.
        </p>
        <a href="https://www.linkedin.com/in/sunil-srivastava-wealth-learning-academy/" target="_blank" class="linkedin-icon" style="display: inline-flex; align-items: center; text-decoration: none; color: #0A66C2;">
          <img src="assets\vision\linkedin.png" alt="LinkedIn" style="width: 24px; margin-right: 8px;" >
          <span>LinkedIn Profile</span>
        </a>
      </div>
      <div class="col-md-6 text-center">
        <img src="assets/vision/sunil.jpg" alt="Mr. Sunil Srivastava" class="img-fluid rounded" style="width: 100%; max-height: 620px; object-fit: cover;">
      </div>
    </div>
  </div>
  
  
  <app-footer></app-footer> 